<!-- 企业认证 -->
<template>
	<div style="width: 700px;">
		<div style="font-size: 16px;color: #767794;margin-top: 40px;">
			当前认证公司:&nbsp;&nbsp;<span style="cursor:pointer;">{{form1.company_name}}</span>
			<img src="./assets/img/edit.png" style="vertical-align: bottom;margin-left: 10px;" @click="open" />
		</div>
		
		<!-- 自定义弹窗 -->
		<el-dialog
			title="请修改认证的公司名称"
			:visible.sync="dialogFormVisible"
			width="500px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			center>
			<div style="padding: 20px;">
				<div style="margin-bottom: 15px; color: #666;">
					当前公司名称: {{form1.company_name}}
				</div>
				<el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm">
					<el-form-item label="新的公司名称" prop="newCompanyName">
						<el-input 
							v-model="dialogForm.newCompanyName" 
							placeholder="请输入新的公司名称"
							@input="handleInputChange">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: center;">
				<el-button 
					@click="cancelDialog" 
					style="margin-right: 10px; width: 100px; height: 40px; border: 2px solid #7eb4eb; color: #7eb4eb; background: transparent;">
					取消
				</el-button>
				<el-button 
					type="primary" 
					@click="confirmDialog"
					:disabled="!dialogForm.newCompanyName.trim()"
					style="width: 100px; height: 40px; background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%); border: none;">
					确认
				</el-button>
			</div>
		</el-dialog>
		<div
			style="width: 100%;height: 140px;background-color: #fff;border-radius: 5px;box-shadow: 0 0 5px 1px rgb(198, 198, 198);margin: 20px auto 10px auto;padding: 20px;">
			<div style="font-size: 19px;color: #656587;font-weight: bold;">在职证明模板</div>
			<div class="download-btn" @click="downloadFileFromApi">
				<img src="./assets/img/Framexiazai.png" style="vertical-align: bottom;" />
				<span style="flex: 1;font-size: 16px;margin-left: 10px;color: #656587;">在职证明模板.docx</span>
				<img src="./assets/img/Group587.png" style="vertical-align: bottom;" />
			</div>
		</div>
		<div style="display: flex;height: 120px;align-items: center;justify-content: center;">
			<img src="./assets/img/Group589.png" style="vertical-align: bottom;" />
			<img src="./assets/img/Union.png" style="vertical-align: bottom;" />
			<img src="./assets/img/Group590.png" style="vertical-align: bottom;" />
			<img src="./assets/img/Union.png" style="vertical-align: bottom;" />
			<img src="./assets/img/Group591.png" style="vertical-align: bottom;" />
		</div>

		<div style="display: flex;align-items: center;justify-content: center;">
			<div class="container">
				<!-- 拖拽上传区域 -->
				<div class="drop-area" :class="{ 'dragover': isDragover, 'uploading': isUploading }"
					@dragover.prevent="handleDragOver" @dragleave.prevent="handleDragLeave" @drop.prevent="handleDrop"
					@click="handleClick">
					<!-- <input type="file" ref="fileInput" class="file-input" multiple accept="image/*,.pdf,.doc,.docx"
						@change="handleFileChange"> -->

					<input :key="fileInputKey" type="file" ref="fileInput" class="file-input" multiple
						accept="image/*,.pdf,.doc,.docx" @change="handleFileChange" @click.stop>

					<div class="upload-text">
						<p class="main-title">上传已加盖公章的在职证明</p>
						<img src="./assets/img/Frame.png" />
						<p class="main-text">点击或拖拽文件到此处上传</p>
						<p class="sub-text">支持JPG、PNG、PDF格式，大小不超过10MB</p>
					</div>
				</div>

				<!-- 上传结果提示 -->
				<!-- <div class="upload-result" v-if="uploadResult.length > 0">
					<div v-for="(result, index) in uploadResult" :key="index" class="result-item"
						:class="result.success ? 'success' : 'error'">
						<span>{{ result.name }}</span>
						<span>{{ result.success ? '上传成功' : '上传失败' }}</span>
					</div>
				</div> -->
			</div>
			<div class="tips-text">
				<div>下载模板后<span class="tips-span">打印</span>并<span class="tips-span">加盖公章</span></div>
				<div>落款日期在<span class="tips-span">60日以内</span></div>
				<div>在证明中需包含公司授权您招聘的信息</div>
			</div>
		</div>

		<div style="font-size: 16px;color: #767794;margin-top: 20px;">
			为了方便您填写认证材料，系统将为您自动填充实名信息，如有问请联系人工客服
		</div>
		<div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;margin-top: 30px;">
			<el-button style="width: 48%;height: 50px;background: linear-gradient(to right, #5ca4ef, #b240ff);-webkit-background-clip: text;
			    background-clip: text;color: transparent;background-color: rgba(210, 211, 208, 0.1);
		      border: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);border-radius: 10px;"
				type="primary" @click="goBack">更换其他验证方式</el-button>

			<el-button style="width: 48%;height: 50px;background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
			  border: transparent;border-radius: 10px;" type="primary" @click="handleNext">开始验证</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getCertification,
		getDownload,
		getBind
	} from '@/api/onTheJob'
	import axios from 'axios';
	export default {
		data() {
			return {
				form: {},
				form1: {
					company_name: "",
					time: '2025年10月01日',
					checkBox: false,
				},
				dialogFormVisible: false,
				// 弹窗表单数据
				dialogForm: {
					newCompanyName: ''
				},
				// 弹窗表单验证规则
				dialogRules: {
					newCompanyName: [
						{ required: true, message: '请输入新的公司名称', trigger: 'blur' },
						{ min: 2, max: 50, message: '公司名称长度在2-50个字符之间', trigger: 'blur' }
					]
				},
				// 是否处于拖拽悬停状态
				isDragover: false,
				// 已选择的文件列表
				files: [],
				// 上传结果
				uploadResult: [],
				// 是否正在上传
				isUploading: false,
				fileInputKey: 0, // 用于强制刷新input元素的key
			};
		},
		created() {
			this.form = JSON.parse(this.$route.query.form)
			this.form1.company_name = this.form.company_name
		},
		methods: {
			open() {
				// 重置表单数据
				this.dialogForm.newCompanyName = '';
				// 显示弹窗
				this.dialogFormVisible = true;
			},
			// 处理输入变化
			handleInputChange() {
				// 可以在这里添加实时验证逻辑
			},
			// 取消弹窗
			cancelDialog() {
				this.dialogFormVisible = false;
				this.dialogForm.newCompanyName = '';
				this.$message({
					type: 'info',
					message: '取消修改'
				});
			},
			// 确认修改
			confirmDialog() {
				this.$refs.dialogForm.validate((valid) => {
					if (valid) {
						// 调用API验证公司名称
						getCertification({
							company_name: this.dialogForm.newCompanyName,
						}).then(async res => {
							if (res.data.code === 200) {
								this.form1.company_name = res.data.data.company_name;
								this.form.company_name = res.data.data.company_name;
								this.dialogFormVisible = false;
								this.dialogForm.newCompanyName = '';
								this.$message({
									type: 'success',
									message: '公司名称修改成功'
								});
							} else {
								this.$message({
									type: 'error',
									message: '您输入的公司不存在！'
								});
							}
						}).catch(err => {
							this.$message({
								type: 'error',
								message: '验证失败，请重试'
							});
						});
					} else {
						this.$message({
							type: 'warning',
							message: '请填写正确的公司名称'
						});
					}
				});
			},
			goBack() {
				this.$confirm('确认更换其他验证方式吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/verify/businessVerificationFunc',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			handleNext() {
				// 触发表单验证
				getBind({
					company_name: this.form.company_name,
					upload_path: 'http://127.0.0.1:8000'
				}).then(async res => {
					if (res.data.code === 1) {
						this.$message({
							type: 'success',
							message: '验证成功'
						});
						this.$router.push({
									path: '/talent',
								});
					} else {

					}
				})
			},
			downloadFileFromApi() {
				try {
					// 实际项目中替换为你的文件下载API

					const response = getDownload({
						name: this.form.name,
						id_card: this.form.idCard,
						company_name: this.form.company_name
					}).then(async res => {
						// 2. 从响应头获取文件名信息
						const contentDisposition = res.headers['content-disposition'];
						if (!contentDisposition) {
							throw new Error('未获取到文件名');
       					}
						// 3. 提取并解码文件名
						const encodedFileName = contentDisposition.split('filename*=UTF-8\'\'')[1];
						const fileName = decodeURIComponent(encodedFileName); 
						// 4. 生成下载链接
						const blob = new Blob([res.data], {
							type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
						});
						const url = URL.createObjectURL(blob);
						const a = document.createElement('a');
						a.href = url;
						a.download = fileName; // 赋值解码后的文件名
						a.click();
						URL.revokeObjectURL(url); // 释放内存
					})
				} catch (error) {
					console.error('文件下载失败:', error);
					this.$message.error('文件下载失败，请重试');
					// this.message = '文件下载失败，请重试';
					// this.messageType = 'error';
				} finally {
					// 重置进度（可选）
					setTimeout(() => {
						// this.downloadProgress = 0;
					}, 2000);
				}
			},
			handleFileDownload(response, defaultFileName) {
				// 从响应头获取文件名（如果后端提供）
				let fileName = defaultFileName;
				const contentDisposition = response.headers['content-disposition'];

				if (contentDisposition) {
					// 解析文件名（处理编码问题）
					const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
					if (matches && matches[1]) {
						fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
					}
				}

				// 创建blob对象
				const blob = new Blob([response.data], {
					type: response.headers['content-type'] || 'application/octet-stream'
				});

				// 创建下载链接
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = fileName;

				// 触发下载
				document.body.appendChild(a);
				a.click();

				// 清理
				setTimeout(() => {
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				}, 100);
			},

			// 处理拖拽悬停
			handleDragOver() {
				this.isDragover = true;
			},
			// 处理拖拽离开
			handleDragLeave() {
				this.isDragover = false;
			},
			// 处理文件放下 - 拖拽后自动上传
			handleDrop(e) {
				this.isDragover = false;
				const droppedFiles = e.dataTransfer.files;
				if (droppedFiles.length) {
					this.addFilesAndUpload(droppedFiles);
				}
			},
			// 点击上传区域，触发文件选择
			handleClick() {
				// this.$refs.fileInput.click();

				// 每次点击都更新key，强制创建新的input元素
				this.fileInputKey += 1;

				// 确保DOM已更新后再触发点击
				this.$nextTick(() => {
					if (this.$refs.fileInput) {
						this.$refs.fileInput.click();
					}
				});
			},
			// 处理文件选择变化 - 选择后自动上传
			handleFileChange(e) {
				const selectedFiles = e.target.files;
				if (selectedFiles.length) {
					this.addFilesAndUpload(selectedFiles);
				}
				// 重置input值，以便可以重复选择同一文件
				// e.target.value = '';
			},

			// 添加文件并立即上传
			addFilesAndUpload(fileList) {
				this.$message({
					type: 'success',
					message: '文件上传成功'
				});
				// 转换为数组以便处理
				// const filesArray = Array.from(fileList);

				// 准备要上传的文件
				// this.files = [];
				// filesArray.forEach(file => {
				// 	// 如果是图片，创建预览（用于上传结果显示）
				// 	if (this.isImage(file)) {
				// 		const reader = new FileReader();
				// 		reader.onload = (e) => {
				// 			file.preview = e.target.result;
				// 			this.files.push(file);

				// 			// 所有文件都准备好后开始上传
				// 			if (this.files.length === filesArray.length) {
				// 				this.uploadFiles();
				// 			}
				// 		};
				// 		reader.readAsDataURL(file);
				// 	} else {
				// 		this.files.push(file);

				// 		// 所有文件都准备好后开始上传
				// 		if (this.files.length === filesArray.length) {
				// 			this.uploadFiles();
				// 		}
				// 	}
				// });
			},
			// 判断是否为图片文件
			isImage(file) {
				return file.type.startsWith('image/');
			},
			// 格式化文件大小
			formatFileSize(bytes) {
				if (bytes === 0) return '0 Bytes';
				const k = 1024;
				const sizes = ['Bytes', 'KB', 'MB', 'GB'];
				const i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
			},
			// 上传文件
			async uploadFiles() {
				if (this.files.length === 0) return;

				this.isUploading = true;

				const formData = new FormData();
				this.files.forEach(file => {
					formData.append('files', file);
				});

				try {
					// 实际项目中替换为你的上传API
					const response = await this.$http.post('/api/upload', formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						onUploadProgress: progressEvent => {
							// 可以在这里处理上传进度
							const percentCompleted = Math.round(
								(progressEvent.loaded * 100) / progressEvent.total
							);
							console.log('上传进度:', percentCompleted);
						}
					});

					// 根据实际API返回结果处理
					if (response.data.success) {
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.files.forEach(file => {
							this.uploadResult.unshift({ // 最新的结果显示在前面
								name: file.name,
								success: true
							});
						});
					} else {
						this.$message.error('上传失败');
						throw new Error('上传失败');
					}
				} catch (error) {
					this.$message.error('上传失败');
					console.error('上传失败:', error);
					this.files.forEach(file => {
						this.uploadResult.unshift({ // 最新的结果显示在前面
							name: file.name,
							success: false
						});
					});
				} finally {
					this.isUploading = false;
					this.files = []; // 清空文件列表
				}
			}
		},
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 0px 18px 18px 0px;
		font-size: large;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.submitButton {
		width: 180px;
		height: 50px;
		border-radius: 18px;
		background-image: linear-gradient(90deg,
				rgba(126, 180, 235, 1) 0,
				rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-top: 20px;
		font-size: x-large;
		cursor: pointer;
	}

	/* 自定义表单样式 - 字体变大加粗 */
	::v-deep .custom-form {
		/* 调整整体表单的字体大小 */
		font-size: 18px;
		margin-top: 10px;
	}

	/* 表单项标签样式 */
	::v-deep .custom-form .el-form-item__label {
		font-weight: bold;
		/* 标签加粗 */
		font-size: 18px;
		/* 标签字体稍大于输入框 */
		color: #333;
		/* 加深标签颜色 */
	}

	/* 输入框内容样式 */
	::v-deep .custom-form .el-input__inner {
		font-size: 18px;
		/* 输入框字体大小 */
		padding: 10px 15px;
		/* 加大输入框内边距，让整体更大气 */
	}

	.download-btn {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		height: 50px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 0 5px 1px rgb(198, 198, 198);
		margin: 20px auto 10px auto;
		padding: 0 20px;
	}
</style>
<style>
	.container {
		width: 300px;
	}

	.drop-area {
		border-radius: 8px;
		padding: 28px 20px;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		background-color: #fff;
		box-shadow: 0 0 5px 1px rgb(198, 198, 198);
	}

	.drop-area.dragover {
		border-color: #42b983;
		background-color: rgba(66, 185, 131, 0.1);
	}

	.drop-area.has-files {
		margin-bottom: 20px;
	}

	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
	}

	.upload-icon {
		font-size: 48px;
		color: #666;
		margin-bottom: 20px;
		transition: color 0.3s ease;
	}

	.drop-area.dragover .upload-icon {
		color: #42b983;
	}

	.upload-text .main-title {
		font-size: 20px;
		font-weight: bold;
		background: linear-gradient(to right, #5ca4ef, #b240ff);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
		background-color: rgba(210, 211, 208, 0.1);
	}


	.upload-text .main-text {
		font-size: 18px;
		color: #333;
		margin: 0 0 10px 0;
	}

	.upload-text .sub-text {
		font-size: 12px;
		color: #666;
		margin: 0;
	}


	.remove-btn {
		background: none;
		border: none;
		color: #e74c3c;
		cursor: pointer;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.2s;
	}

	.remove-btn:hover {
		background-color: rgba(231, 76, 60, 0.1);
	}

	.upload-btn {
		background-color: #42b983;
		color: white;
		border: none;
		padding: 10px 20px;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
		margin-top: 15px;
		transition: background-color 0.3s;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.upload-btn:disabled {
		background-color: #95a5a6;
		cursor: not-allowed;
	}

	.upload-btn:hover:not(:disabled) {
		background-color: #359469;
	}

	.upload-btn i {
		margin-right: 8px;
	}

	.upload-result {
		margin-top: 20px;
		padding-top: 20px;
		border-top: 1px solid #eee;
	}

	.result-item {
		padding: 8px 10px;
		margin-bottom: 5px;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
	}

	.result-item.success {
		background-color: rgba(66, 185, 131, 0.1);
		color: #27ae60;
	}

	.result-item.error {
		background-color: rgba(231, 76, 60, 0.1);
		color: #e74c3c;
	}

	.tips-text {
		background-color: #f7f9fa;
		border-radius: 8px;
		width: 300px;
		height: 200px;
		line-height: 50px;
		padding: 28px 20px;
		text-align: left;
		font-size: 15px;
		color: #666;
		box-shadow: 0 0 5px 1px rgb(198, 198, 198);
	}

	.tips-span {
		font-size: 15px;
		font-weight: bold;
		background: linear-gradient(to right, #5ca4ef, #b240ff);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
		background-color: rgba(210, 211, 208, 0.1);
	}
</style>